import { Typography } from '@material-ui/core';
import React, { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import { useStyles } from './styles';

export interface DefaultDocumentsProps {
  className?: string;
  /**
   * Whether this stage's list can hold an offer letter template — attached, or
   * available to attach (AXHE-4226). An offer letter does not send on landing,
   * so the sentence describing the list has to say so once one can appear in it.
   * False leaves the copy exactly as it reads for a legacy-only stage.
   */
  hasOfferLetterTemplates?: boolean;
  /**
   * Whether the stage's send-on-landing setting is on, which sends a signature
   * template on landing too. Read only with `hasOfferLetterTemplates`.
   */
  sendsDocumentsOnLanding?: boolean;
}

export const DefaultDocuments: VFC<DefaultDocumentsProps> = ({
  className,
  hasOfferLetterTemplates = false,
  sendsDocumentsOnLanding = false,
}) => {
  const styles = useStyles();

  let description = messages.manageDocuments;
  if (hasOfferLetterTemplates) {
    description = sendsDocumentsOnLanding
      ? messages.manageDocumentsSentOnLanding
      : messages.manageDocumentsWithOfferLetterTemplates;
  }

  return (
    <div className={className}>
      <Typography
        className={styles.marginBottom2}
        color="textPrimary"
        variant="h4"
      >
        <FormattedMessage {...messages.defaultDocuments} />
      </Typography>
      <Typography color="textPrimary" variant="body2">
        <FormattedMessage {...description} />
      </Typography>
    </div>
  );
};
